export default "__VITE_ASSET__ohyDOfHH__"